<script lang="ts" setup>
import { ref } from "vue";
import { useLazyload } from "vue3-lazyload";

const props = defineProps({
    imgUrl: {
        type: String,
        required: true,
    },
    altText: {
        type: String,
        required: true,
    },
    width: {
        type: Number,
        default: 100,
        required: false,
    },
});

const src = ref(props.imgUrl);
const lazyRef = useLazyload(src);
</script>
<template>
    <img :alt="altText" ref="lazyRef" :width="width" />
</template>
